import {
  OperationParameter,
  OperationURLParameter,
  OperationQueryParameter,
} from "@azure/core-client";

export const accept: OperationParameter = {
  parameterPath: "accept",
  mapper: {
    defaultValue: "application/json",
    isConstant: true,
    serializedName: "Accept",
    type: {
      name: "String",
    },
  },
};

export const $host: OperationURLParameter = {
  parameterPath: "$host",
  mapper: {
    serializedName: "$host",
    required: true,
    type: {
      name: "String",
    },
  },
  skipEncoding: true,
};

export const accountId: OperationURLParameter = {
  parameterPath: "accountId",
  mapper: {
    constraints: {
      Pattern: new RegExp("^ak_\\w{38,50}$"),
    },
    serializedName: "accountId",
    required: true,
    type: {
      name: "String",
    },
  },
};

export const ownedOnly: OperationQueryParameter = {
  parameterPath: ["options", "ownedOnly"],
  mapper: {
    serializedName: "owned_only",
    type: {
      name: "Boolean",
    },
  },
};

export const typeParam: OperationQueryParameter = {
  parameterPath: ["options", "type"],
  mapper: {
    serializedName: "type",
    type: {
      name: "Enum",
      allowedValues: [
        "transactions",
        "aexn",
        "aex9",
        "aex141",
        "contract",
        "transfers",
        "claims",
        "swaps",
      ],
    },
  },
};

export const limit: OperationQueryParameter = {
  parameterPath: ["options", "limit"],
  mapper: {
    defaultValue: 10,
    constraints: {
      InclusiveMaximum: 100,
      InclusiveMinimum: 1,
    },
    serializedName: "limit",
    type: {
      name: "Number",
    },
  },
};

export const scope: OperationQueryParameter = {
  parameterPath: ["options", "scope"],
  mapper: {
    constraints: {
      Pattern: new RegExp("(gen):\\d+(-\\d+)?"),
    },
    serializedName: "scope",
    type: {
      name: "String",
    },
  },
};

export const direction: OperationQueryParameter = {
  parameterPath: ["options", "direction"],
  mapper: {
    serializedName: "direction",
    type: {
      name: "Enum",
      allowedValues: ["forward", "backward"],
    },
  },
};

export const direction1: OperationQueryParameter = {
  parameterPath: ["options", "direction"],
  mapper: {
    serializedName: "direction",
    type: {
      name: "Enum",
      allowedValues: ["forward", "backward"],
    },
  },
};

export const contract: OperationQueryParameter = {
  parameterPath: ["options", "contract"],
  mapper: {
    constraints: {
      Pattern: new RegExp("^ct_\\w{38,50}$"),
    },
    serializedName: "contract",
    type: {
      name: "String",
    },
  },
};

export const direction2: OperationQueryParameter = {
  parameterPath: ["options", "direction"],
  mapper: {
    serializedName: "direction",
    type: {
      name: "Enum",
      allowedValues: ["forward", "backward"],
    },
  },
};

export const direction3: OperationQueryParameter = {
  parameterPath: ["options", "direction"],
  mapper: {
    serializedName: "direction",
    type: {
      name: "Enum",
      allowedValues: ["forward", "backward"],
    },
  },
};

export const direction4: OperationQueryParameter = {
  parameterPath: ["options", "direction"],
  mapper: {
    serializedName: "direction",
    type: {
      name: "Enum",
      allowedValues: ["forward", "backward"],
    },
  },
};

export const by: OperationQueryParameter = {
  parameterPath: ["options", "by"],
  mapper: {
    serializedName: "by",
    type: {
      name: "Enum",
      allowedValues: ["creation", "name", "symbol"],
    },
  },
};

export const prefix: OperationQueryParameter = {
  parameterPath: ["options", "prefix"],
  mapper: {
    serializedName: "prefix",
    type: {
      name: "String",
    },
  },
};

export const exact: OperationQueryParameter = {
  parameterPath: ["options", "exact"],
  mapper: {
    serializedName: "exact",
    type: {
      name: "String",
    },
  },
};

export const direction5: OperationQueryParameter = {
  parameterPath: ["options", "direction"],
  mapper: {
    serializedName: "direction",
    type: {
      name: "Enum",
      allowedValues: ["forward", "backward"],
    },
  },
};

export const contractId: OperationURLParameter = {
  parameterPath: "contractId",
  mapper: {
    constraints: {
      Pattern: new RegExp("^ct_\\w{38,50}$"),
    },
    serializedName: "contractId",
    required: true,
    type: {
      name: "String",
    },
  },
};

export const direction6: OperationQueryParameter = {
  parameterPath: ["options", "direction"],
  mapper: {
    serializedName: "direction",
    type: {
      name: "Enum",
      allowedValues: ["forward", "backward"],
    },
  },
};

export const templateId: OperationURLParameter = {
  parameterPath: "templateId",
  mapper: {
    serializedName: "templateId",
    required: true,
    type: {
      name: "Number",
    },
  },
};

export const direction7: OperationQueryParameter = {
  parameterPath: ["options", "direction"],
  mapper: {
    serializedName: "direction",
    type: {
      name: "Enum",
      allowedValues: ["forward", "backward"],
    },
  },
};

export const tokenId: OperationURLParameter = {
  parameterPath: "tokenId",
  mapper: {
    serializedName: "tokenId",
    required: true,
    type: {
      name: "Number",
    },
  },
};

export const direction8: OperationQueryParameter = {
  parameterPath: ["options", "direction"],
  mapper: {
    serializedName: "direction",
    type: {
      name: "Enum",
      allowedValues: ["forward", "backward"],
    },
  },
};

export const fromParam: OperationQueryParameter = {
  parameterPath: ["options", "from"],
  mapper: {
    constraints: {
      Pattern: new RegExp("^ak_\\w{38,50}$"),
    },
    serializedName: "from",
    type: {
      name: "String",
    },
  },
};

export const to: OperationQueryParameter = {
  parameterPath: ["options", "to"],
  mapper: {
    constraints: {
      Pattern: new RegExp("^ak_\\w{38,50}$"),
    },
    serializedName: "to",
    type: {
      name: "String",
    },
  },
};

export const id: OperationURLParameter = {
  parameterPath: "id",
  mapper: {
    constraints: {
      Pattern: new RegExp("^ct_\\w{38,50}$"),
    },
    serializedName: "id",
    required: true,
    type: {
      name: "String",
    },
  },
};

export const direction9: OperationQueryParameter = {
  parameterPath: ["options", "direction"],
  mapper: {
    serializedName: "direction",
    type: {
      name: "Enum",
      allowedValues: ["forward", "backward"],
    },
  },
};

export const by1: OperationQueryParameter = {
  parameterPath: ["options", "by"],
  mapper: {
    serializedName: "by",
    type: {
      name: "Enum",
      allowedValues: ["creation", "name", "symbol"],
    },
  },
};

export const direction10: OperationQueryParameter = {
  parameterPath: ["options", "direction"],
  mapper: {
    serializedName: "direction",
    type: {
      name: "Enum",
      allowedValues: ["forward", "backward"],
    },
  },
};

export const by2: OperationQueryParameter = {
  parameterPath: ["options", "by"],
  mapper: {
    serializedName: "by",
    type: {
      name: "String",
    },
  },
};

export const blockHash: OperationQueryParameter = {
  parameterPath: ["options", "blockHash"],
  mapper: {
    constraints: {
      Pattern: new RegExp("^mh_\\w{38,50}$"),
    },
    serializedName: "block_hash",
    type: {
      name: "String",
    },
  },
};

export const hash: OperationQueryParameter = {
  parameterPath: ["options", "hash"],
  mapper: {
    constraints: {
      Pattern: new RegExp("^mh_\\w{38,50}$"),
    },
    serializedName: "hash",
    type: {
      name: "String",
    },
  },
};

export const direction11: OperationQueryParameter = {
  parameterPath: ["options", "direction"],
  mapper: {
    serializedName: "direction",
    type: {
      name: "Enum",
      allowedValues: ["forward", "backward"],
    },
  },
};

export const direction12: OperationQueryParameter = {
  parameterPath: ["options", "direction"],
  mapper: {
    serializedName: "direction",
    type: {
      name: "Enum",
      allowedValues: ["forward", "backward"],
    },
  },
};

export const state: OperationQueryParameter = {
  parameterPath: ["options", "state"],
  mapper: {
    serializedName: "state",
    type: {
      name: "Enum",
      allowedValues: ["active", "inactive"],
    },
  },
};

export const id1: OperationURLParameter = {
  parameterPath: "id",
  mapper: {
    constraints: {
      Pattern: new RegExp("^ch_\\w{38,50}$"),
    },
    serializedName: "id",
    required: true,
    type: {
      name: "String",
    },
  },
};

export const direction13: OperationQueryParameter = {
  parameterPath: ["options", "direction"],
  mapper: {
    serializedName: "direction",
    type: {
      name: "Enum",
      allowedValues: ["forward", "backward"],
    },
  },
};

export const contractId1: OperationQueryParameter = {
  parameterPath: ["options", "contractId"],
  mapper: {
    constraints: {
      Pattern: new RegExp("^ct_\\w{38,50}$"),
    },
    serializedName: "contract_id",
    type: {
      name: "String",
    },
  },
};

export const event: OperationQueryParameter = {
  parameterPath: ["options", "event"],
  mapper: {
    serializedName: "event",
    type: {
      name: "String",
    },
  },
};

export const functionParam: OperationQueryParameter = {
  parameterPath: ["options", "function"],
  mapper: {
    serializedName: "function",
    type: {
      name: "String",
    },
  },
};

export const functionPrefix: OperationQueryParameter = {
  parameterPath: ["options", "functionPrefix"],
  mapper: {
    serializedName: "function_prefix",
    type: {
      name: "String",
    },
  },
};

export const data: OperationQueryParameter = {
  parameterPath: ["options", "data"],
  mapper: {
    serializedName: "data",
    type: {
      name: "String",
    },
  },
};

export const aexnArgs: OperationQueryParameter = {
  parameterPath: ["options", "aexnArgs"],
  mapper: {
    serializedName: "aexn-args",
    type: {
      name: "Boolean",
    },
  },
};

export const direction14: OperationQueryParameter = {
  parameterPath: ["options", "direction"],
  mapper: {
    serializedName: "direction",
    type: {
      name: "Enum",
      allowedValues: ["forward", "backward"],
    },
  },
};

export const direction15: OperationQueryParameter = {
  parameterPath: ["options", "direction"],
  mapper: {
    serializedName: "direction",
    type: {
      name: "Enum",
      allowedValues: ["forward", "backward"],
    },
  },
};

export const direction16: OperationQueryParameter = {
  parameterPath: ["options", "direction"],
  mapper: {
    serializedName: "direction",
    type: {
      name: "Enum",
      allowedValues: ["forward", "backward"],
    },
  },
};

export const contractId2: OperationURLParameter = {
  parameterPath: "contractId",
  mapper: {
    constraints: {
      Pattern: new RegExp("^ct_\\w{38,50}$"),
    },
    serializedName: "contract_id",
    required: true,
    type: {
      name: "String",
    },
  },
};

export const direction17: OperationQueryParameter = {
  parameterPath: ["options", "direction"],
  mapper: {
    serializedName: "direction",
    type: {
      name: "Enum",
      allowedValues: ["forward", "backward"],
    },
  },
};

export const scope1: OperationQueryParameter = {
  parameterPath: ["options", "scope"],
  mapper: {
    constraints: {
      Pattern: new RegExp("(epoch):\\d+(-\\d+)?"),
    },
    serializedName: "scope",
    type: {
      name: "String",
    },
  },
};

export const direction18: OperationQueryParameter = {
  parameterPath: ["options", "direction"],
  mapper: {
    serializedName: "direction",
    type: {
      name: "Enum",
      allowedValues: ["forward", "backward"],
    },
  },
};

export const height: OperationURLParameter = {
  parameterPath: "height",
  mapper: {
    serializedName: "height",
    required: true,
    type: {
      name: "Number",
    },
  },
};

export const direction19: OperationQueryParameter = {
  parameterPath: ["options", "direction"],
  mapper: {
    serializedName: "direction",
    type: {
      name: "Enum",
      allowedValues: ["forward", "backward"],
    },
  },
};

export const validator: OperationURLParameter = {
  parameterPath: "validator",
  mapper: {
    constraints: {
      Pattern: new RegExp("^ak_\\w{38,50}$"),
    },
    serializedName: "validator",
    required: true,
    type: {
      name: "String",
    },
  },
};

export const direction20: OperationQueryParameter = {
  parameterPath: ["options", "direction"],
  mapper: {
    serializedName: "direction",
    type: {
      name: "Enum",
      allowedValues: ["forward", "backward"],
    },
  },
};

export const direction21: OperationQueryParameter = {
  parameterPath: ["options", "direction"],
  mapper: {
    serializedName: "direction",
    type: {
      name: "Enum",
      allowedValues: ["forward", "backward"],
    },
  },
};

export const direction22: OperationQueryParameter = {
  parameterPath: ["options", "direction"],
  mapper: {
    serializedName: "direction",
    type: {
      name: "Enum",
      allowedValues: ["forward", "backward"],
    },
  },
};

export const hashOrKbi: OperationURLParameter = {
  parameterPath: "hashOrKbi",
  mapper: {
    serializedName: "hash_or_kbi",
    required: true,
    type: {
      name: "String",
    },
  },
};

export const direction23: OperationQueryParameter = {
  parameterPath: ["options", "direction"],
  mapper: {
    serializedName: "direction",
    type: {
      name: "Enum",
      allowedValues: ["forward", "backward"],
    },
  },
};

export const hash1: OperationURLParameter = {
  parameterPath: "hash",
  mapper: {
    constraints: {
      Pattern: new RegExp("^mh_\\w{38,50}$"),
    },
    serializedName: "hash",
    required: true,
    type: {
      name: "String",
    },
  },
};

export const ownedBy: OperationQueryParameter = {
  parameterPath: ["options", "ownedBy"],
  mapper: {
    constraints: {
      Pattern: new RegExp("^ak_\\w{38,50}$"),
    },
    serializedName: "owned_by",
    type: {
      name: "String",
    },
  },
};

export const state1: OperationQueryParameter = {
  parameterPath: ["options", "state"],
  mapper: {
    serializedName: "state",
    type: {
      name: "String",
    },
  },
};

export const direction24: OperationQueryParameter = {
  parameterPath: ["options", "direction"],
  mapper: {
    serializedName: "direction",
    type: {
      name: "Enum",
      allowedValues: ["forward", "backward"],
    },
  },
};

export const direction25: OperationQueryParameter = {
  parameterPath: ["options", "direction"],
  mapper: {
    serializedName: "direction",
    type: {
      name: "Enum",
      allowedValues: ["forward", "backward"],
    },
  },
};

export const id2: OperationURLParameter = {
  parameterPath: "id",
  mapper: {
    serializedName: "id",
    required: true,
    type: {
      name: "String",
    },
  },
};

export const direction26: OperationQueryParameter = {
  parameterPath: ["options", "direction"],
  mapper: {
    serializedName: "direction",
    type: {
      name: "Enum",
      allowedValues: ["forward", "backward"],
    },
  },
};

export const direction27: OperationQueryParameter = {
  parameterPath: ["options", "direction"],
  mapper: {
    serializedName: "direction",
    type: {
      name: "Enum",
      allowedValues: ["forward", "backward"],
    },
  },
};

export const direction28: OperationQueryParameter = {
  parameterPath: ["options", "direction"],
  mapper: {
    serializedName: "direction",
    type: {
      name: "Enum",
      allowedValues: ["forward", "backward"],
    },
  },
};

export const direction29: OperationQueryParameter = {
  parameterPath: ["options", "direction"],
  mapper: {
    serializedName: "direction",
    type: {
      name: "Enum",
      allowedValues: ["forward", "backward"],
    },
  },
};

export const direction30: OperationQueryParameter = {
  parameterPath: ["options", "direction"],
  mapper: {
    serializedName: "direction",
    type: {
      name: "Enum",
      allowedValues: ["forward", "backward"],
    },
  },
};

export const direction31: OperationQueryParameter = {
  parameterPath: ["options", "direction"],
  mapper: {
    serializedName: "direction",
    type: {
      name: "Enum",
      allowedValues: ["forward", "backward"],
    },
  },
};

export const id3: OperationURLParameter = {
  parameterPath: "id",
  mapper: {
    constraints: {
      Pattern: new RegExp("^ok_\\w{38,50}$"),
    },
    serializedName: "id",
    required: true,
    type: {
      name: "String",
    },
  },
};

export const intervalBy: OperationQueryParameter = {
  parameterPath: ["options", "intervalBy"],
  mapper: {
    serializedName: "interval_by",
    type: {
      name: "Enum",
      allowedValues: ["day", "week", "month"],
    },
  },
};

export const direction32: OperationQueryParameter = {
  parameterPath: ["options", "direction"],
  mapper: {
    serializedName: "direction",
    type: {
      name: "Enum",
      allowedValues: ["forward", "backward"],
    },
  },
};

export const intervalBy1: OperationQueryParameter = {
  parameterPath: ["options", "intervalBy"],
  mapper: {
    serializedName: "interval_by",
    type: {
      name: "Enum",
      allowedValues: ["day", "week", "month"],
    },
  },
};

export const minStartDate: OperationQueryParameter = {
  parameterPath: ["options", "minStartDate"],
  mapper: {
    serializedName: "min_start_date",
    type: {
      name: "String",
    },
  },
};

export const maxStartDate: OperationQueryParameter = {
  parameterPath: ["options", "maxStartDate"],
  mapper: {
    serializedName: "max_start_date",
    type: {
      name: "String",
    },
  },
};

export const direction33: OperationQueryParameter = {
  parameterPath: ["options", "direction"],
  mapper: {
    serializedName: "direction",
    type: {
      name: "Enum",
      allowedValues: ["forward", "backward"],
    },
  },
};

export const intervalBy2: OperationQueryParameter = {
  parameterPath: ["options", "intervalBy"],
  mapper: {
    serializedName: "interval_by",
    type: {
      name: "Enum",
      allowedValues: ["day", "week", "month"],
    },
  },
};

export const typeParam1: OperationQueryParameter = {
  parameterPath: ["options", "type"],
  mapper: {
    serializedName: "type",
    type: {
      name: "Enum",
      allowedValues: ["key", "micro"],
    },
  },
};

export const direction34: OperationQueryParameter = {
  parameterPath: ["options", "direction"],
  mapper: {
    serializedName: "direction",
    type: {
      name: "Enum",
      allowedValues: ["forward", "backward"],
    },
  },
};

export const intervalBy3: OperationQueryParameter = {
  parameterPath: ["options", "intervalBy"],
  mapper: {
    serializedName: "interval_by",
    type: {
      name: "Enum",
      allowedValues: ["day", "week", "month"],
    },
  },
};

export const direction35: OperationQueryParameter = {
  parameterPath: ["options", "direction"],
  mapper: {
    serializedName: "direction",
    type: {
      name: "Enum",
      allowedValues: ["forward", "backward"],
    },
  },
};

export const direction36: OperationQueryParameter = {
  parameterPath: ["options", "direction"],
  mapper: {
    serializedName: "direction",
    type: {
      name: "Enum",
      allowedValues: ["forward", "backward"],
    },
  },
};

export const intervalBy4: OperationQueryParameter = {
  parameterPath: ["options", "intervalBy"],
  mapper: {
    serializedName: "interval_by",
    type: {
      name: "Enum",
      allowedValues: ["day", "week", "month"],
    },
  },
};

export const direction37: OperationQueryParameter = {
  parameterPath: ["options", "direction"],
  mapper: {
    serializedName: "direction",
    type: {
      name: "Enum",
      allowedValues: ["forward", "backward"],
    },
  },
};

export const intervalBy5: OperationQueryParameter = {
  parameterPath: ["options", "intervalBy"],
  mapper: {
    serializedName: "interval_by",
    type: {
      name: "Enum",
      allowedValues: ["day", "week", "month"],
    },
  },
};

export const direction38: OperationQueryParameter = {
  parameterPath: ["options", "direction"],
  mapper: {
    serializedName: "direction",
    type: {
      name: "Enum",
      allowedValues: ["forward", "backward"],
    },
  },
};

export const direction39: OperationQueryParameter = {
  parameterPath: ["options", "direction"],
  mapper: {
    serializedName: "direction",
    type: {
      name: "Enum",
      allowedValues: ["forward", "backward"],
    },
  },
};

export const intervalBy6: OperationQueryParameter = {
  parameterPath: ["options", "intervalBy"],
  mapper: {
    serializedName: "interval_by",
    type: {
      name: "Enum",
      allowedValues: ["day", "week", "month"],
    },
  },
};

export const direction40: OperationQueryParameter = {
  parameterPath: ["options", "direction"],
  mapper: {
    serializedName: "direction",
    type: {
      name: "Enum",
      allowedValues: ["forward", "backward"],
    },
  },
};

export const direction41: OperationQueryParameter = {
  parameterPath: ["options", "direction"],
  mapper: {
    serializedName: "direction",
    type: {
      name: "Enum",
      allowedValues: ["forward", "backward"],
    },
  },
};

export const intervalBy7: OperationQueryParameter = {
  parameterPath: ["options", "intervalBy"],
  mapper: {
    serializedName: "interval_by",
    type: {
      name: "Enum",
      allowedValues: ["day", "week", "month"],
    },
  },
};

export const direction42: OperationQueryParameter = {
  parameterPath: ["options", "direction"],
  mapper: {
    serializedName: "direction",
    type: {
      name: "Enum",
      allowedValues: ["forward", "backward"],
    },
  },
};

export const intervalBy8: OperationQueryParameter = {
  parameterPath: ["options", "intervalBy"],
  mapper: {
    serializedName: "interval_by",
    type: {
      name: "Enum",
      allowedValues: ["day", "week", "month"],
    },
  },
};

export const txType: OperationQueryParameter = {
  parameterPath: ["options", "txType"],
  mapper: {
    serializedName: "tx_type",
    type: {
      name: "String",
    },
  },
};

export const direction43: OperationQueryParameter = {
  parameterPath: ["options", "direction"],
  mapper: {
    serializedName: "direction",
    type: {
      name: "Enum",
      allowedValues: ["forward", "backward"],
    },
  },
};

export const typeParam2: OperationQueryParameter = {
  parameterPath: ["options", "type"],
  mapper: {
    serializedName: "type",
    type: {
      name: "Sequence",
      element: {
        type: {
          name: "Enum",
          allowedValues: [
            "channel_close_mutual",
            "channel_close_solo",
            "channel_create",
            "channel_deposit",
            "channel_force_progress",
            "channel_offchain",
            "channel_settle",
            "channel_slash",
            "channel_snapshot_solo",
            "channel_withdraw",
            "contract_call",
            "contract_create",
            "ga_attach",
            "ga_meta",
            "name_claim",
            "name_preclaim",
            "name_revoke",
            "name_transfer",
            "name_update",
            "oracle_extend",
            "oracle_query",
            "oracle_register",
            "oracle_response",
            "paying_for",
            "spend",
          ],
        },
      },
    },
  },
  collectionFormat: "Multi",
};

export const typeGroup: OperationQueryParameter = {
  parameterPath: ["options", "typeGroup"],
  mapper: {
    serializedName: "type_group",
    type: {
      name: "Sequence",
      element: {
        type: {
          name: "Enum",
          allowedValues: [
            "channel",
            "contract",
            "ga",
            "name",
            "oracle",
            "paying_for",
            "spend",
          ],
        },
      },
    },
  },
  collectionFormat: "Multi",
};

export const account: OperationQueryParameter = {
  parameterPath: ["options", "account"],
  mapper: {
    constraints: {
      Pattern: new RegExp("^ak_\\w{38,50}$"),
    },
    serializedName: "account",
    type: {
      name: "String",
    },
  },
};

export const channel: OperationQueryParameter = {
  parameterPath: ["options", "channel"],
  mapper: {
    constraints: {
      Pattern: new RegExp("^ch_\\w{38,50}$"),
    },
    serializedName: "channel",
    type: {
      name: "String",
    },
  },
};

export const oracle: OperationQueryParameter = {
  parameterPath: ["options", "oracle"],
  mapper: {
    constraints: {
      Pattern: new RegExp("^ok_\\w{38,50}$"),
    },
    serializedName: "oracle",
    type: {
      name: "String",
    },
  },
};

export const senderId: OperationQueryParameter = {
  parameterPath: ["options", "senderId"],
  mapper: {
    constraints: {
      Pattern: new RegExp("^ak_\\w{38,50}$"),
    },
    serializedName: "sender_id",
    type: {
      name: "String",
    },
  },
};

export const recipientId: OperationQueryParameter = {
  parameterPath: ["options", "recipientId"],
  mapper: {
    constraints: {
      Pattern: new RegExp("^ak_\\w{38,50}$"),
    },
    serializedName: "recipient_id",
    type: {
      name: "String",
    },
  },
};

export const entrypoint: OperationQueryParameter = {
  parameterPath: ["options", "entrypoint"],
  mapper: {
    serializedName: "entrypoint",
    type: {
      name: "String",
    },
  },
};

export const scope2: OperationQueryParameter = {
  parameterPath: ["options", "scope"],
  mapper: {
    constraints: {
      Pattern: new RegExp("(time|gen):\\d+(-\\d+)?"),
    },
    serializedName: "scope",
    type: {
      name: "String",
    },
  },
};

export const direction44: OperationQueryParameter = {
  parameterPath: ["options", "direction"],
  mapper: {
    serializedName: "direction",
    type: {
      name: "Enum",
      allowedValues: ["forward", "backward"],
    },
  },
};

export const id4: OperationQueryParameter = {
  parameterPath: ["options", "id"],
  mapper: {
    constraints: {
      Pattern: new RegExp("^ak_\\w{38,50}$"),
    },
    serializedName: "id",
    type: {
      name: "String",
    },
  },
};

export const direction45: OperationQueryParameter = {
  parameterPath: ["options", "direction"],
  mapper: {
    serializedName: "direction",
    type: {
      name: "Enum",
      allowedValues: ["forward", "backward"],
    },
  },
};

export const hash2: OperationURLParameter = {
  parameterPath: "hash",
  mapper: {
    constraints: {
      Pattern: new RegExp("^th_\\w{38,50}$"),
    },
    serializedName: "hash",
    required: true,
    type: {
      name: "String",
    },
  },
};

export const direction46: OperationQueryParameter = {
  parameterPath: ["options", "direction"],
  mapper: {
    serializedName: "direction",
    type: {
      name: "Enum",
      allowedValues: ["forward", "backward"],
    },
  },
};
